<template>
    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{ title }}</h1>
            </div>

            <div class="table__form">

                <!-- PARAMETRI -->
                <div class="multiple">
                    <h2>Parametri</h2>

                    <div class="info-box">
                        Parametri per considerare accesso da campagna
                    </div>
                    <ul class="parameterList">
                        <li class="parameterList--inner" v-for="(parameter, parameterIndex) in parameters" :key="parameterIndex">
                            <div class="param-header">
                                <input type="text" v-model="parameter.name" placeholder="Parameter name">
                                <div class="flex-gap">
                                    <i
                                        class="fal fa-indent"
                                        @click="addCondition(parameterIndex, [])"
                                    />
                                    <i class="fal fa-trash-alt" @click="deleteParameter(parameterIndex)"></i>
                                </div>
                            </div>

                            <ConditionNode
                                v-for="(condition, conditionIndex) in parameter.conditions"
                                :key="conditionIndex"
                                :condition="condition"
                                :parent-index="parameterIndex"
                                :path="[conditionIndex]"
                                :siblings-length="parameter.conditions.length"
                                :is-last="conditionIndex === parameter.conditions.length - 1"
                                @delete="deleteCondition"
                            />
                        </li>
                    </ul>

                    <div class="add_btn">
                        <input class="insert" type="button" value="Aggiungi Parametro" @click="addParameter">
                    </div>
                </div>

                <!-- SCRIPT -->
                <div class="multiple">
                    <h2>Scripts</h2>

                    <div class="info-box">
                        Script inclusi per ogni progetto
                    </div>

                    <draggable
                        :list="scriptsList"
                        handle=".fa-arrows-alt-v"
                        item-key="id"
                    >
                        <div v-for="(script, scriptIndex) in scriptsList" :key="script.id">
                            <div v-if="!script.deleted" class="flex_scripts" :style="{
                            border: '1px solid #ddd',
                            padding: '10px',
                            background: '#fff',
                            opacity: script.active == 0 ? 0.6 : 1
                          }">

                                <!-- Icona solo se può modificare -->
                                <i
                                    class="fal fa-arrows-alt-v"
                                    @click="deleteScript(scriptIndex)"
                                ></i>

                                <select v-model="script.active">
                                    <option value="1">Enabled</option>
                                    <option value="0">Disabled</option>
                                </select>

                                <select v-model="script.platform">
                                    <option value="1">All platform</option>
                                    <option value="2">Web site</option>
                                    <option value="3">Booking</option>
                                </select>

                                <select v-model="script.type_id">
                                    <option :value="null">Load</option>
                                    <option
                                        v-for="(scriptType, currentIndex) in scriptTypes"
                                        :key="scriptType.id"
                                        :value="scriptType.id"
                                        v-if="scriptType.translations.length > 0"
                                    >
                                        {{ scriptType.translations[0].translation }}
                                    </option>
                                </select>

                                <textarea v-model="script.script"></textarea>

                                <i
                                    class="fal fa-trash-alt"
                                    @click="deleteScript(scriptIndex)"
                                ></i>

                            </div>
                        </div>
                    </draggable>

                    <div class="add_btn">
                        <input class="insert" type="button" value="Aggiungi Script" @click="addScript">
                    </div>
                </div>

                <!-- ACCESSIBILITA -->
                <div class="multiple">
                    <h2>Testi generici</h2>

                    <div class="info-box">
                        Testi generici di default per i progetti
                    </div>

                    <div class="table__form">

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Testo Link Accessibilità</strong>
                            </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>
                                <div v-for="language in languages" v-bind:key="language.id">
                                    <div v-if="languageSelected == language.slug">
                                        <input type="text" v-model="texts.accessibilityLabel[language.id]">
                                        <div class="mt10" style="margin-top: 10px;">
                                            <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accessibilityLabel" @click="deeplTranslate('accessibilityLabel', texts.accessibilityLabel[language.id])">
                                                <span v-if="!translating.accessibilityLabel">Traduci con AI</span>
                                                <span v-else>
                                                    <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Titolo Accessibilità - Sito</strong>
                            </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>
                                <div v-for="language in languages" v-bind:key="language.id">
                                    <div v-if="languageSelected == language.slug">
                                        <input type="text" v-model="texts.accessibilityTitleSite[language.id]">
                                        <div class="mt10" style="margin-top: 10px;">
                                            <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accessibilityTitleSite" @click="deeplTranslate('accessibilityTitleSite', texts.accessibilityTitleSite[language.id])">
                                                <span v-if="!translating.accessibilityTitleSite">Traduci con AI</span>
                                                <span v-else>
                                                    <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Testo Accessibilità - Sito</strong>
                            </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>
                                <div v-for="language in languages" v-bind:key="language.id">
                                    <div v-if="languageSelected == language.slug">
                                        <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                            plugins: ['lists link image paste help wordcount code'],
                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                        }" v-model="texts.accessibilityTextSite[language.id]"></editor>
                                        <div class="mt10" style="margin-top: 10px;">
                                            <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accessibilityTextSite" @click="deeplTranslate('accessibilityTextSite', texts.accessibilityTextSite[language.id])">
                                                <span v-if="!translating.accessibilityTextSite">Traduci con AI</span>
                                                <span v-else>
                                                    <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Titolo Accessibilità - Booking</strong>
                            </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>
                                <div v-for="language in languages" v-bind:key="language.id">
                                    <div v-if="languageSelected == language.slug">
                                        <input type="text" v-model="texts.accessibilityTitleBooking[language.id]">
                                        <div class="mt10" style="margin-top: 10px;">
                                            <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accessibilityTitleBooking" @click="deeplTranslate('accessibilityTitleBooking', texts.accessibilityTitleBooking[language.id])">
                                                <span v-if="!translating.accessibilityTitleBooking">Traduci con AI</span>
                                                <span v-else>
                                                    <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form_inline">
                            <div class="w-25 mr-2">
                        <strong class="label-form">Testo Accessibilità - Booking</strong>
                    </div>
                            <div class="translations">
                                <ul class="change-languages">
                                    <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                        <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                                    </li>
                                </ul>
                                <div v-for="language in languages" v-bind:key="language.id">
                                    <div v-if="languageSelected == language.slug">
                                        <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                            plugins: ['lists link image paste help wordcount code'],
                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                        }" v-model="texts.accessibilityTextBooking[language.id]"></editor>
                                        <div class="mt10" style="margin-top: 10px;">
                                            <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accessibilityTextBooking" @click="deeplTranslate('accessibilityTextBooking', texts.accessibilityTextBooking[language.id])">
                                                <span v-if="!translating.accessibilityTextBooking">Traduci con AI</span>
                                                <span v-else>
                                                    <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- SALVA -->
                <div class="bcm_action" style="display: flex; justify-content: space-between; align-items: center">

                    <div>
                        <div>
                            <div><strong>Update</strong>: {{ details.requestLogUpade }}</div>
                        </div>
                    </div>
                    <input type="button" value="Salva" @click="saveSettings">
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields'
import ConditionNode from './ConditionNode.vue'
import draggable from 'vuedraggable';
import Editor from '@tinymce/tinymce-vue';
import axios from "axios";
import langMap from '../../../assets/twocharlanguage.json';
import flagMixin from '../../../mixins/flagMixin';

export default {
    mixins: [flagMixin],
    components: {
        ConditionNode,
        draggable,
        Editor
    },
    data() {
        return {
            title: 'Settaggi',
            translating: {
                accessibilityLabel: false,
                accessibilityTitleSite: false,
                accessibilityTextSite: false,
                accessibilityTitleBooking: false,
                accessibilityTextBooking: false,
            }
        }
    },
    computed: {
        ...mapGetters(
            {
                details: 'settingsModule/details',
                languages: 'settingsModule/languages',
                languageSelected: 'settingsModule/languageSelected',
                texts: 'settingsModule/texts',
            }
        ),
        //...mapGetters('settingsModule', ['details']),
        ...mapMultiRowFields('settingsModule', ['scripts', 'scriptTypes', 'parameters']),
        scriptsList:{
            get() {
                return this.$store.state.settingsModule.scripts;
            },
            set(val) {
                this.$store.commit('settingsModule/updateScriptsOrder', evt);
            }
        },
        languageSelected: {
            set(val){
                this.$store.state.librariesModule.languageSelected = val
            },
            get(){
                return this.$store.state.librariesModule.languageSelected
            }
        },
    },
    methods: {
        loadSettings() {
            this.$store.dispatch('settingsModule/loadSettings', { urlToConnect: 'settings' })

        },
        saveSettings() {
            const parameters = {
                urlToConnect: 'settings',
                methodToConnect: 'post',
                scripts: this.$store.state.settingsModule.scripts,
                parameters: this.$store.state.settingsModule.parameters,
                texts: this.$store.state.settingsModule.texts,
            }
            this.$store.dispatch('settingsModule/saveSettings', parameters)
        },
        addScript() {
            this.$store.commit('settingsModule/addScript')
        },
        deleteScript(id) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('settingsModule/deleteScript', id)
            }
        },
        addParameter() {
            this.$store.commit('settingsModule/addParameter')
        },
        deleteParameter(id) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('settingsModule/deleteParameter', id)
            }
        },
        addCondition(parameterIndex, path) {
            this.$store.commit('settingsModule/addCondition', {
                parentIndex: parameterIndex,
                path: path || []
            });
        },
        deleteCondition(parameterIndex, path, conditionIndex) {
            if (confirm('Are you sure?')) {
                this.$store.commit('settingsModule/deleteCondition', {
                    parentIndex: parameterIndex,
                    path,
                    index: conditionIndex
                });
            }
        },
        languageSelect (slug) {
            this.$store.dispatch('librariesModule/languageSelect', {slug: slug})
        },

        async deeplTranslate(field, textToTranslate) {
            if (this.translating[field]) return;

            this.$set(this.translating, field, true);

            const selectedLang = this.languageSelected;
            const languageObj = this.languages.find(l => l.slug === selectedLang);
            const sourceLang = langMap[languageObj.slug.toLowerCase()];

            const targetLangs = this.languages
                .filter(l => {
                    const iso2 = langMap[l.slug.toLowerCase()];
                    return iso2 && iso2 !== sourceLang;
                })
                .map(l => langMap[l.slug.toLowerCase()]);

            if (!textToTranslate || !targetLangs.length) {
                this.$set(this.translating, field, false);
                return;
            }

            const { text, tokens } = this.prepareForTranslation(textToTranslate);

            try {
                const payload = {
                    Text: [text],
                    SourceLang: sourceLang,
                    TargetLanguages: targetLangs,
                    Context: 'cookie description'
                };

                const response = await axios.post('/deepl-translate', payload);
                const data = response.data;

                if (!data.IsSucceded) {
                    throw new Error(data.Errors || 'Errore traduzione');
                }

                data.Data.forEach(translation => {
                    if (!translation || !translation.Translations || !translation.Translations.length || !translation.Translations[0]) {
                        return;
                    }

                    const translatedRaw = translation.Translations[0].Text;
                    const langCode = translation.Translations[0].TargetLanguage;

                    if (!translatedRaw || !translatedRaw.trim()) {
                        console.warn('Traduzione vuota per', langCode);
                        return;
                    }

                    const langObj = this.languages.find(l => {
                        if (!l.slug) return false;
                        const iso2 = langMap[l.slug.toLowerCase()];
                        return iso2 && iso2 === langCode;
                    });

                    if (!langObj) return;

                    if (!this.texts[field]) {
                        this.$set(this.texts, field, {});
                    }

                    // RIPRISTINO HTML
                    const finalText = this.restoreAfterTranslation(translatedRaw, tokens);

                    // impostiamo la traduzione per la lingua
                    this.$set(this.texts[field], langObj.id, finalText);
                });

            } catch (err) {
                console.error('Errore durante la traduzione:', err);
            } finally {
                // levo il flag di traduzione
                this.$set(this.translating, field, false);
            }
        },

        prepareForTranslation(html) {
            if (!html) return { text: '', tokens: [] };

            const tokens = [];
            let index = 0;

            const tokenize = match => {
                const key = `[${index}]`;
                tokens.push({ key, value: match });
                index++;
                return key;
            };

            // 🔒 Protegge i placeholder tipo |*LISTA DOMINI*| affinché DeepL non li traduca/alteri
            let text = html.replace(/\|\*.*?\*\|/g, tokenize);

            text = text.replace(/<[^>]+>/g, match => {
                if (/^<br\s*\/?>$/i.test(match)) {
                    return match;
                }

                return tokenize(match);
            });

            return { text, tokens };
        },

        restoreAfterTranslation(translatedText, tokens) {
            let result = translatedText;

            tokens.forEach(t => {
                result = result.replaceAll(t.key, t.value);
            });

            // normalizza BR duplicati
            result = result.replace(/(<br\s*\/?>\s*){2,}/gi, '<br />');

            return result;
        }

    },
    watch: {
        '$route'() {
            this.loadSettings()
        }
    },
    created() {
        this.loadSettings()
    }
}
</script>
